
import { mapActions, mapState } from "pinia"
import { useStore } from "@/store/PiniaStore"
import { ProspectSearchCriteria } from "@/lib/InterfacesAndTypes"
import ProspectSearchResultsGrid from './ProspectSearchResultsGrid.vue'
import { defineComponent } from "vue"

export default defineComponent({
	components: { ProspectSearchResultsGrid },
	props: {
		search: {
			type: Object as () => ProspectSearchCriteria,
			required: true,
		},
	},
	computed: {
		...mapState(useStore, ["searchesActive"]),
	},
	methods: {
		...mapActions(useStore, ["addSearch", "submitSearch", "closeSearch", "duplicateSearch"]),

		setFocus(fieldNum: number = 1) {
			const elem: any = this.$refs[`field${fieldNum}`]
			if (elem) {
				elem.focus()
			}
		},

		// Auto-format DOB as MM/DD/YYYY: slashes are inserted/removed automatically so
		// the user only ever types or backspaces digits.
		onDobInput(value: string) {
			const input: HTMLInputElement | undefined = (this.$refs.field5 as any)?.$refs?.input
			const rawCaret = input?.selectionStart ?? value.length
			const digitsBeforeCaret = value.slice(0, rawCaret).replace(/\D/g, "").length

			const digits = value.replace(/\D/g, "").slice(0, 8)
			let formatted = digits.slice(0, 2)
			if (digits.length > 2) {
				formatted += "/" + digits.slice(2, 4)
			}
			if (digits.length > 4) {
				formatted += "/" + digits.slice(4, 8)
			}
			this.search.fields.dateOfBirth = formatted

			this.$nextTick(() => {
				if (!input) {
					return
				}
				let pos = 0
				let seen = 0
				while (pos < formatted.length && seen < digitsBeforeCaret) {
					if (/\d/.test(formatted[pos])) {
						seen++
					}
					pos++
				}
				while (pos < formatted.length && formatted[pos] === "/") {
					pos++
				}
				input.setSelectionRange(pos, pos)
			})
		},
	},

	mounted(): void {
		console.log(`ProspectSearchCard mounted`)
	},
})
